"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Hayk.Andriasyan on 5/31/2017.
 */
var BooleanExpression = /** @class */ (function () {
    function BooleanExpression(_currentFilters) {
        this._currentFilters = _currentFilters;
        this.operator = null;
    }
    BooleanExpression.prototype.addFilter = function (filter) {
        this.operator !== null ? this.operator.children.push(filter) : this._currentFilters.push(filter);
    };
    return BooleanExpression;
}());
exports.BooleanExpression = BooleanExpression;
//# sourceMappingURL=boolean-expression.js.map